import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { CashSaleCreateDTO, CashSaleResult, CashSaleSettings } from '../interfaces/sales/cashSale.interface';
import { SalesInvoicePage } from '../interfaces/sales/salesInvoice.interface';

// FW-2B: one-step invoice + receipt. Nothing here e-mails the customer.
export const CashSaleService = {
  create: async (dto: CashSaleCreateDTO): Promise<CashSaleResult> =>
    (await axios.post(ENDPOINTS.CASH_SALE.BASE, dto)).data,
  voidSale: async (id: string, reason: string): Promise<CashSaleResult> =>
    (await axios.post(ENDPOINTS.CASH_SALE.VOID(id), { reason })).data,
  list: async (institutionId: string, params: { from?: string; to?: string; customerId?: string; search?: string; page?: number; size?: number }): Promise<SalesInvoicePage> =>
    (await axios.get(ENDPOINTS.CASH_SALE.LIST(institutionId), { params })).data,
  getSettings: async (institutionId: string): Promise<CashSaleSettings> =>
    (await axios.get(ENDPOINTS.CASH_SALE.SETTINGS(institutionId))).data,
  saveSettings: async (dto: CashSaleSettings): Promise<CashSaleSettings> =>
    (await axios.put(ENDPOINTS.CASH_SALE.SAVE_SETTINGS, dto)).data,
  createWalkInCustomer: async (institutionId: string): Promise<CashSaleSettings> =>
    (await axios.post(ENDPOINTS.CASH_SALE.WALK_IN_CUSTOMER(institutionId))).data,
};
